import React from 'react';
import { MenuItem as MuiMenuItem } from '@material-ui/core';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { useTheme } from "../../hooks/useTheme";
import { Typography } from "../Typography/Typography";
var styles = function (theme) { return ({
    root: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
        height: theme.spacing(7.5),
        cursor: 'pointer',
        minHeight: theme.spacing(5),
    },
    light: {
        backgroundColor: theme.palette.light.background.paper,
        color: theme.palette.light.text.primary,
        '&$selected': {
            backgroundColor: theme.palette.primary['50'],
            color: theme.palette.light.text.primary,
        },
        '&:hover:not($selected)': {
            backgroundColor: theme.palette.primary['50'],
            color: theme.palette.light.text.primary,
        },
        '&$focusVisible': {
            backgroundColor: theme.palette.primary['50'],
            color: theme.palette.light.text.primary,
        },
        '&:active:hover': {
            backgroundColor: theme.palette.primary.light,
            borderColor: theme.palette.primary.light,
            color: theme.palette.common.white,
        },
    },
    dark: {
        backgroundColor: theme.palette.dark.background.paper,
        color: theme.palette.dark.text.primary,
        '&$selected': {
            backgroundColor: theme.palette.dark.background.paper,
            color: theme.palette.primary.light,
        },
        '&:hover:not($selected)': {
            backgroundColor: theme.palette.dark.background.paper,
            color: theme.palette.primary.light,
        },
        '&$focusVisible': {
            backgroundColor: theme.palette.dark.background.paper,
            color: theme.palette.primary.light,
        },
        '&:active:hover': {
            backgroundColor: theme.palette.primary.light,
            borderColor: theme.palette.primary.light,
            color: theme.palette.common.white,
        },
    },
    selected: {},
    dense: {
        height: theme.spacing(5),
    },
    // Material-UIのスタイルを上書きするため、ここで一旦定義することで詳細度を上げる。
    focusVisible: {},
}); };
var useStyles = makeStyles(styles, { name: 'SnSelectItem' });
export var SelectItem = React.forwardRef(function (props, ref) {
    var _a;
    var label = props.label, value = props.value, selected = props.selected, dense = props.dense, onClose = props.onClose, autoFocus = props.autoFocus, tabIndex = props.tabIndex;
    var theme = useTheme(props);
    var classes = useStyles(props);
    var rootClassName = classNames(classes.root, classes[theme.type], (_a = {},
        _a[classes.selected] = selected,
        _a[classes.dense] = dense,
        _a));
    var handleClick = function () {
        onClose(value);
    };
    return (React.createElement(MuiMenuItem, { className: rootClassName, focusVisibleClassName: classes.focusVisible, disableRipple: true, ref: ref, tabIndex: tabIndex, autoFocus: autoFocus, onClick: handleClick },
        React.createElement(Typography, { variant: dense ? 'body1' : 'title', noWrap: true }, label)));
});
